var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapClusterMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    width: 22,
    height: 27.143,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M805.9,118.6c-178.4-142.8-433.4-142.8-611.7,0l77.6,77.6c134.9-101.1,321.6-101.1,456.5,0L805.9,118.6z",
    fill: "#fdbb1d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7,273.3l-77.6-77.6C-37,388-24.8,669.6,153.5,848c81.8,81.8,185.3,128.6,292,140.5V878.7c-78.7-11.3-154.5-47.2-215-107.7C94.7,635.2,82.8,422.5,194.7,273.3z",
    fill: "#e96a24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M882.9,195.6l-77.6,77.6c111.9,149.3,100,362-35.8,497.7c-60.5,60.5-136.4,96.4-215,107.7v109.8c106.7-11.9,210.2-58.7,292-140.5C1024.8,669.6,1037,388,882.9,195.6z",
    fill: "#65a844"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapClusterMarker);
export default __webpack_public_path__ + "static/media/map_cluster_marker.920d4b4de26bca40e80115510466ab56.svg";
export { ForwardRef as ReactComponent };